import eyerCloud from '@/config/eyercloud'

const DEFAULT_FREE_LIMIT = 10000

class DashboardService {
  async getClinicUsage(params) {
    let response = await eyerCloud.post(`/api/v2/eyercloud/clinic/usage/get`, params)
    return response.data
  }

  getPlanLimit(subscriptionName, allProductsData) {
    if (subscriptionName === 'Corporate')
      return 'unlimited';

    const activeProduct = allProductsData[subscriptionName];
    const rawLimit = activeProduct?.metadata?.captures_limit;

    if (rawLimit === 'unlimited')
      return 'unlimited';

    if (rawLimit)
      return parseInt(rawLimit);

    return DEFAULT_FREE_LIMIT;
  }

  getPercentageValue(used, limit) {
    console.log(used, limit);
    if (limit === 'unlimited' || !limit || limit === 0)
      return 0;

    let percentage = ((used / limit) * 100).toFixed(2);
    return percentage > 100 ? 100 : percentage
  }

  getPercentageClass(percentage) {
    if (percentage > 70 && percentage < 90)
      return 'warning'
    else if (percentage >= 90)
      return 'danger'

    return ''
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
